<template>
    

    <div>
        <div v-if="is_super_admin">
            <div style="padding: 0px 16px;">
                <el-button plain type="primary" @click="addVipPrivilege" size="small" icon="el-icon-plus" :disabled="addDisabled">客服电话</el-button>
                
                <el-tag class="my-tag-style" type="danger">
                    已有客服电话时,不允许新增
                </el-tag>
            </div>

            <div style="padding: 10px 16px;">
                <el-table
                    :data="lServiceList"
                    style="width: 100%;border-color:'#606266'"
                    :default-sort = "{prop: 'date', order: 'descending'}"
                    :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
                    :cell-style="{color: '#666',fontSize:'14px'}"
                    border
                >
                <el-table-column
                        fixed
                        align="center"
                        prop="service_id"
                        label="ID"
                        sortable
                        width="100px"
                        >
                    </el-table-column>

                    <el-table-column
                        fixed
                        align="center"
                        prop="service_phone"
                        label="客服电话"
                        >
                    </el-table-column>

                    <el-table-column
                        align="center"
                        label="操作"
                        width="200px"
                    >
                        <template slot-scope="scope">
                            <el-button round icon="el-icon-delete" type="danger" size="small" @click="deleteFunc(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <el-dialog :visible.sync="bShowDialog" :before-close="this.$dialog_close" :fullscreen="bShowFullscreen" :show-close="false">
                <div slot="title" class="dialog-title">
                    <span style="font-size: 18px; line-height: 24px; color: #303133;">{{ sDialogName }}</span>
                    <el-button icon="el-icon-close" class='dialog-title-button' @click="bShowDialog = false"></el-button>
                    <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="bShowFullscreen = !bShowFullscreen"></el-button>
                </div>

                <el-form :model="dFromData" ref="dFromData" labeel-width="100px" @class="demo-dFromData">
                    <el-input v-model="dFromData.service_phone" placeholder="请输入客服电话"></el-input>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="cancelFunc">取 消</el-button>
                    <el-button type="primary" @click="defineFunc">确 定</el-button>
                </div>

            </el-dialog>
        </div>

        <div v-else>
            <div style="text-align: center;">
                <div style="margin-top: 0px;">
                <img src="../assets/permission_denied.png">
                <div style="margin-top: 20px;">
                    <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ServiceSystem",
    data(){
        return {
            bShowDialog: false,
            bShowFullscreen: false,
            sDialogName: '新增客服电话',
            dFromData: {},
            lServiceList: [],
            addDisabled: false,
            is_super_admin: false,
        }
    },

    mounted(){
        // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
        let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
        if (isSuperAdmin == "false") {
            this.is_super_admin = false
            return
        } else {
            this.is_super_admin = true
        }
        this.getServicePhone();
    },

    methods: {
        async getServicePhone(){
            let url = '/api/service/'
            let res = await this.$axios.get(url)
            console.log(res)
            this.lServiceList = res.data

            if (this.lServiceList.length > 0) {
                this.addDisabled = true
            }else{
                this.addDisabled = false
            }
        
        },

        addVipPrivilege(){
            this.bShowDialog = true;
            this.sDialogName = '新增客服电话';
            this.dFromData = {}
        },

        // 确定
        async defineFunc(){
            let url = '/api/service/'
            this.dFromData.service_type = 0
            await this.$axios.post(url, this.dFromData)
            this.bShowDialog = false
            this.getServicePhone()
        },
        // 取消
        cancelFunc(){
            this.bShowDialog = false;
        },
        // 删除事件
        deleteFunc(row){
            var _this = this
            this.$confirm('此操作将永久删除该数据', '删除消息警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                _this.$axios.delete('/api/service/' + row.service_id + '/').then(
                function(res){_this.$message({type: 'success', message: '删除成功!'});
                _this.getServicePhone()})
            }).catch(() => {
                _this.$message({type: 'info',message: '已取消删除'});          
            });
        },

    },
}
</script>

<style scoped>
.my-tag-style{
    margin-left: 10px;
    margin-right: 100px;
}
</style>